import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Footer from '../../Include/Footer';
import Header from '../../Include/Header';
import Sidebar from '../../Include/Sidebar';
import Loader from '../../Include/Loader';
import { Pagination } from '../../Table';
import { getProPoPending } from '../../../../Store/prosafe/proReport/getProPoPending';
import PageHeader from '../../Components/PageHeader/PageHeader';
import { getParty } from '../../../../Store/Store/Party/Party';
import moment from 'moment';
import useDebounce from '../../../../hooks/useDebounce';
import Swal from 'sweetalert2';
import axios from 'axios';
import { V_URL } from '../../../../BaseUrl';
import toast from 'react-hot-toast';

const ProPoPending = () => {

    const dispatch = useDispatch();
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [limit, setlimit] = useState(20);

    const [filter, setFilter] = useState({
        startDate: "",
        endDate: "",
        party_id: ""
    });

    const debouncedStartDate = useDebounce(filter.startDate, 400);
    const debouncedEndDate = useDebounce(filter.endDate, 400);

    useEffect(() => {
        const payload = {
            firm_id: localStorage.getItem('PAY_USER_FIRM_ID'),
            tag_number: 10,
            party_id: filter.party_id,
            start_date: debouncedStartDate,
            end_date: debouncedEndDate
        }

        dispatch(getProPoPending(payload))
    }, [dispatch, filter.party_id, debouncedStartDate, debouncedEndDate]);

    useEffect(() => {
        dispatch(getParty({ is_main: true }));
    }, [dispatch]);

    const entity = useSelector((state) => state?.getProPoPending?.user?.data);
    const isLoading = useSelector((state) => state?.getProPoPending?.loading);
    const partyData = useSelector((state) => state?.getParty?.user?.data);

    const partyOptions = partyData?.map((party) => ({
        label: party.name,
        value: party._id,
    }));

    const commentsData = useMemo(() => {
        let computedComments = entity || [];
        if (search.trim() !== "") {
            const lowerSearch = search.toLowerCase();
            computedComments = computedComments.filter((item) =>
                item?.item_data?.name?.toLowerCase().includes(lowerSearch) ||
                item?.po_no?.toLowerCase().includes(lowerSearch) ||
                item?.item_no?.toLowerCase().includes(lowerSearch)
            );
        }
        setTotalItems(computedComments?.length);
        return computedComments?.slice(
            (currentPage - 1) * limit,
            (currentPage - 1) * limit + limit
        );
    }, [currentPage, search, limit, entity]);

    const handleRefresh = () => {
        setFilter({
            startDate: "",
            endDate: "",
            party_id: ""
        });
        setSearch("");
        setCurrentPage(1);

        const payload = {
            firm_id: localStorage.getItem('PAY_USER_FIRM_ID'),
            tag_number: 10,
            party_id: "",
            start_date: "",
            end_date: ""
        }
        dispatch(getProPoPending(payload))
    }

    const handleCloseItem = (elem) => {
        Swal.fire({
            title: `Are you sure to close ${elem?.po_no}?`,
            html: `You want to close this item: <b>${elem?.item_data?.name}?</b>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, close it!'
        }).then((result) => {
            if (result.isConfirmed) {
                const payload = {
                    from_id: elem.from_id,
                    detail_id: elem.detail_id,
                }
                axios({
                    method: 'post',
                    url: `${V_URL}/prosafe/close-po-pr-item`,
                    data: payload,
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
                    },
                }).then((response) => {
                    if (response.data.success) {
                        toast.success(response.data.message);
                        handleRefresh();
                    } else {
                        toast.error(response.data.message);
                    }
                }).catch((error) => {
                    toast.error(error.response?.data?.message || "Something went wrong");
                })
            }
        })
    }

    const handleFilterChange = (newFilter) => {
        setFilter(newFilter);
        setCurrentPage(1);
    };

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const handleOpen = () => {
        setIsSidebarOpen(!isSidebarOpen)
    }

    const breadCrumbs = [
        { label: "Dashboard", link: "/main-store/user/dashboard" },
        { label: "PO Pending List" },
    ];

    const filterConfig = [
        {
            key: "startDate",
            label: "Start Date",
            type: "date",
            value: filter.startDate,
            placeholder: "Select Start Date",
        },
        {
            key: "endDate",
            label: "End Date",
            type: "date",
            value: filter.endDate,
            placeholder: "Select End Date",
        },
        {
            key: "party_id",
            label: "Party",
            type: "dropdown",
            value: filter?.party_id || "",
            options: partyOptions,
            placeholder: "Select Party",
        },
    ];

    return (
        <div className={`main-wrapper ${isSidebarOpen ? 'slide-nav' : ''}`}>
            <Header handleOpen={handleOpen} />
            <Sidebar />
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card card-table show-entire">
                                <div className="card-body">
                                    <PageHeader
                                        title="PO Pending List"
                                        breadcrumbs={breadCrumbs}
                                        onSearch={(value) => {
                                            setSearch(value);
                                            setCurrentPage(1);
                                        }}
                                        onRefresh={handleRefresh}
                                        filter={filter}
                                        onFilterChange={handleFilterChange}
                                        limit={limit}
                                        onLimitChange={(val) => setlimit(val)}
                                        filterConfig={filterConfig}
                                    />
                                    {isLoading ? (
                                        <Loader />
                                    ) : (
                                        <div className="table-responsive">
                                            <table className="table border-0 custom-table comman-table  mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Sr.</th>
                                                        <th>Date</th>
                                                        <th>PO No</th>
                                                        <th>Project Name</th>
                                                        <th>Party Name</th>
                                                        <th>Item No</th>
                                                        <th>Item Name</th>
                                                        <th>Item Weight</th>
                                                        <th>Quantity</th>
                                                        <th>Received Qty</th>
                                                        <th>Balance Qty</th>
                                                        {/* <th>Item Length</th>
                                                        <th>Item Width</th> */}
                                                        {/* <th>Item Radius</th>
                                                        <th>Item Thickness</th>
                                                        <th>Assembly Weight</th>
                                                        <th>Assembly Surface Area</th> */}
                                                        <th>Rate (₹)</th>
                                                        <th>GST (%)</th>
                                                        <th>Closed At</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {commentsData?.map((elem, i) =>
                                                        <tr key={i}>
                                                            <td>{(currentPage - 1) * limit + i + 1}</td>
                                                            <td>{elem?.trans_date ? moment(elem?.trans_date).format('DD-MM-YYYY') : "-"}</td>
                                                            <td>{elem?.po_no || "-"}</td>
                                                            <td>{elem?.project_data?.name || "-"}</td>
                                                            <td>{elem?.party_data?.name || "-"}</td>
                                                            <td>{elem?.item_no || "-"}</td>
                                                            <td>{elem?.item_data?.name || "-"}</td>
                                                            <td>{elem?.item_weight ?? "-"}</td>
                                                            <td>{elem?.quantity ?? "-"}</td>
                                                            <td>{(elem?.quantity - elem.balance_qty) ?? "-"}</td>
                                                            <td>{elem?.balance_qty ?? "-"}</td>
                                                            {/* <td>{elem?.item_length ?? "-"}</td>
                                                            <td>{elem?.item_width ?? "-"}</td> */}
                                                            {/* <td>{elem?.item_radius ?? "-"}</td>
                                                            <td>{elem?.item_thickness ?? "-"}</td>
                                                            <td>{elem?.assembly_weight ?? "-"}</td> */}
                                                            {/* <td>{elem?.assembly_surface_area ?? "-"}</td> */}
                                                            <td>{elem?.rate ?? "-"}</td>
                                                            <td>{elem?.gst ?? "-"}</td>
                                                            <td>{elem?.item_is_closed_at ? moment(elem?.item_is_closed_at).format('DD-MM-YYYY hh:mm A') : "-"}</td>
                                                            <td className='text-center'>
                                                                {!elem?.item_is_closed ? (
                                                                    <button
                                                                        className="btn btn-danger btn-sm "
                                                                        style={{ fontSize: "12px", padding: "3px 5px" }}
                                                                        onClick={() => handleCloseItem(elem)}
                                                                    >
                                                                        Close
                                                                    </button>
                                                                ) : (
                                                                    <div className='text-right'>
                                                                        <span
                                                                            className='text-danger'
                                                                            style={{ fontSize: "12px", padding: "3px 5px" }}
                                                                        >
                                                                            Closed
                                                                        </span>
                                                                    </div>
                                                                )}
                                                            </td>

                                                        </tr>
                                                    )}
                                                    {commentsData?.length === 0 ? (
                                                        <tr>
                                                            <td colSpan="15">
                                                                <div className="no-table-data">
                                                                    No Data Found!
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ) : null}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}

                                    <div className="row align-center mt-3 mb-2">
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                                            <div className="dataTables_info" id="DataTables_Table_0_info" role="status"
                                                aria-live="polite">Showing {Math.min(limit, totalItems)} from {totalItems} data</div>
                                        </div>
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                                            <div className="dataTables_paginate paging_simple_numbers"
                                                id="DataTables_Table_0_paginate">
                                                <Pagination
                                                    total={totalItems}
                                                    itemsPerPage={limit}
                                                    currentPage={currentPage}
                                                    onPageChange={(page) => setCurrentPage(page)}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    )
}

export default ProPoPending